import React from 'react';

import { LoadableAfterPaint } from '@confluence/loadable';
import { PageSegmentLoadStart } from '@confluence/browser-metrics/entry-points/PageSegmentLoadStart';

import { ShareButtonPlaceholder } from '../src/ShareButtonPlaceholder';
import { SHARE_BUTTON_PAGE_SEGMENT_LOAD } from '../src/perf.config';
import type { ShareComponentProps } from '../src/ShareButton';

export type { ShareContentType } from '../src/ShareButton';

// Adding a separate Invite Button loader temporarily as a workaround for the custom placeholder not working in SSR
export const InviteButton = LoadableAfterPaint<any>({
	loader: async () =>
		(await import(/* webpackChunkName: "loadable-ShareButton" */ '../src/ShareButton')).ShareButton,
});

const ShareButtonLoader = LoadableAfterPaint<any>({
	loader: async () =>
		(await import(/* webpackChunkName: "loadable-ShareButton" */ '../src/ShareButton')).ShareButton,
	loading: ShareButtonPlaceholder,
});

export const ShareButton = (props: ShareComponentProps) => (
	<>
		<PageSegmentLoadStart
			metric={SHARE_BUTTON_PAGE_SEGMENT_LOAD}
			isCustomStart
			key={props.contentId}
		/>
		<ShareButtonLoader {...props} />
	</>
);
